import { addGuidelines } from '@/components/Editor/helpers/Guidelines';
import { FabricCanvas } from '@/components/Editor/types/fabric';
import { ToggleTypes } from '@/types';

export const mouseDown = (
  canvas: FabricCanvas,
  toggle: ToggleTypes,
): void => {
  canvas[toggle]('mouse:down', addGuidelines);
};
